import cn from 'classnames';

type Props = {
  title: string;
  className?: string;
};

export default function DivideSliderItem(props: Props) {
  return (
    <div
      className={cn(
        `bg-neutral-10 absolute z-20 flex h-12 w-full flex-col items-center justify-center`,
        props.className
      )}
    >
      <h4 className="text-body16 desktop:text-subtitle18 font-bold text-black">
        {props.title}
      </h4>
    </div>
  );
}
